var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"contactMedia"},[_c('div',{staticClass:"middle"},[_c('div',{staticClass:"fz24 bl"},[_vm._v("壹心保代公众号")]),_c('div',[_c('img',{attrs:{"src":require("../assets/images/QRcode.jpeg"),"alt":""}})]),_c('div',{staticClass:"c999"},[_vm._v(" 扫码关注了解更多 ")]),_c('div',{staticClass:"line"})])])
}]

export { render, staticRenderFns }